// extracted by mini-css-extract-plugin
module.exports = {"container":"InviteFriends--container--3aAge","button":"InviteFriends--button--y0T1h"};